import { ViewProvider } from "./provider/ViewContext";
import CustomerDashboardComponent from "./CustomerDashboardComponent";

const CustomerDashboard: React.FC = () => {
	return (
		<ViewProvider>
			<CustomerDashboardComponent />
		</ViewProvider>
	);
};
export default CustomerDashboard;
